export const EVENTCODES = {
	Travel10Off: "TRAVEL10OFF"
}